import angular from 'angular';
import Api from './api/api';
import Loader from './loader/loader';
import Authorisation from './authorisation/authorisation';
import CustomFilters from './filters/filters';
import Event from './entity/event/event';
import Location from './entity/location/location';
import LocationAccess from './entity/locationAccess/locationAccess';
import LocationType from './entity/locationType/locationType';
import Advert from './entity/advert/advert';
/* flagged for removal with task VRCSTORE-1037
import PushMessages from './entity/pushMessage/pushMessage';
*/
import Racedays from './entity/racedays/racedays';
import LinkType from './entity/linkType/linkType';
import SocialCategory from './entity/socialCategory/socialCategory';
import Filters from './entity/filters/filters';
import StateStore from './stateStore/stateStore';
import DynamicLink from './entity/dynamicLink/dynamicLink';

let commonModule = angular.module('app.common', [
  Api,
  Loader,
  Authorisation,
  CustomFilters,
  Event,
  Location,
  LocationAccess,
  LocationType,
  Advert,
  /* flagged for removal with task VRCSTORE-1037
  PushMessages,
  */
  Racedays,
  LinkType,
  SocialCategory,
  Filters,
  StateStore,
  DynamicLink
])

.name;

export default commonModule;
